import { render, staticRenderFns } from "./hutchdutchsettlement.vue?vue&type=template&id=dc82b996&scoped=true"
import script from "./hutchdutchsettlement.vue?vue&type=script&lang=js"
export * from "./hutchdutchsettlement.vue?vue&type=script&lang=js"
import style0 from "./hutchdutchsettlement.vue?vue&type=style&index=0&id=dc82b996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc82b996",
  null
  
)

export default component.exports